import { HttpErrorResponse, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ACT_AS_HEADER, ActAsService } from './act-as.service';

/** While staff act for a firm, API calls carry its slug; the backend decides which endpoints honour it. */
export const actAsInterceptor: HttpInterceptorFn = (req, next) => {
  const actAs = inject(ActAsService);
  const actingFor = actAs.actingFor();
  const base = environment.apiUrl.replace(/\/+$/, '');
  // A path boundary after the base: a bare prefix would also match e.g. `${base}.attacker.example`.
  const isApiRequest = req.url === base || req.url.startsWith(`${base}/`);
  if (!actingFor || !isApiRequest) {
    return next(req);
  }
  // Realm management stays in the staff member's own context.
  if (req.url.slice(base.length).replace(/^\/+/, '').startsWith('master/')) {
    return next(req);
  }
  // Tracked so ending waits for it, and dropped if it answers after the session ended: a late
  // firm response must not overwrite the caller's own restored data.
  const request = actAs.trackFirmRequest();
  return next(req.clone({ setHeaders: { [ACT_AS_HEADER]: actingFor.slug } })).pipe(
    map(event => {
      if (event.type === HttpEventType.Response && !actAs.isCurrentEpoch(request.epoch)) {
        throw new HttpErrorResponse({ url: req.url, status: 0, statusText: 'Acting for the firm has ended' });
      }
      return event;
    }),
    finalize(request.done),
  );
};
